// ClubService.getCategories with the same retry-with-backoff as HomeScreen.fetchCategories (:560-590).
import { useCallback, useEffect, useRef, useState } from "react";
import { ClubService } from "../../../../services/clubService";

const RETRY_DELAYS_MS = [0, 1000, 3000];

export default function useCategories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  // Each load (and each effect run, incl. StrictMode's double setup) takes a new
  // generation; only the latest may write state.
  const gen = useRef(0);

  const load = useCallback(async () => {
    const mine = ++gen.current;
    setLoading(true);
    setFailed(false);
    for (const delay of RETRY_DELAYS_MS) {
      if (delay) await new Promise((r) => setTimeout(r, delay));
      if (mine !== gen.current) return;
      const { data, error } = await ClubService.getCategories();
      if (mine !== gen.current) return;
      if (!error) {
        setCategories(Array.isArray(data) ? data : []);
        setLoading(false);
        return;
      }
    }
    if (mine !== gen.current) return;
    setFailed(true);
    setLoading(false);
  }, []);

  useEffect(() => {
    load();
    const g = gen;
    return () => { g.current += 1; };
  }, [load]);

  return { categories, loading, failed, reload: load };
}
